import { $enum } from "ts-enum-util";

import { FileTypes } from "../models";

export const getAcceptedFileTypes = (imageOnly?: boolean): string =>
    $enum(FileTypes)
        .getValues()
        .filter((fileTypes) => (imageOnly ? fileTypes.includes("image") : true))
        .join(",");
